import React from "react";
import "./home.scss";
import Header from "../Section/Header/navbar";
import Banner from "../Section/Banner/banner";
import About from "../Section/AP/AP";
import Promo from "../Section/Promo/promo";
import Bischofia from "../Section/Bischofia/Bischofia";
import Calamus from "../Section/Calamus/Calamus";
import Dalbergia from "../Section/Dalbergia/Dalbergia";
import Surrounding from "../Section/Fasilitas/fasilitas";
import Lokasi from "../Section/Lokasi/lokasi";
import Footer from "../Section/Footer/Footer";
import Scrolltohashelement from "../Pages/ScrollToHashElement";

const home = () => {
  return (
    <div className="home">
      <Scrolltohashelement />
      <Header />
      <Banner />
      <About />
      <Promo />
      <Dalbergia />
      <Calamus />
      <Bischofia />
      <Surrounding />
      <Lokasi />
      <Footer />
    </div>
  );
};

export default home;
